import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import { uploadConsentTypeAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLoading } from "../../selectors";
import FileInput from "@icarius-common/fileUpload/fileInput";
import FileList from "@icarius-common/fileUpload/fileList";

const UploadFilesAction = (props) => {

  const { open, code, handleClose } = props;

  const [files, setFiles] = useState(null);
  const [failedDocuments, setFailedDocuments] = useState(null);

  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);

  const handleSubmit = () => {
    setFailedDocuments(null);
    if (dataIsValid()) {
      dispatch(uploadConsentTypeAction(files[0], code))
        .then((resp) => {
          if (resp?.status === 200) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("documentUploadedOK"), severity: "success" }));
            handleClose();
          } else {
            setFailedDocuments(resp?.data?.invalidFiles)
          }
        });
    } else {
      dispatch(openSnackbarAction({ msg: getLocalizedString("youMustChooseADocument"), severity: "error" }));
    }
  };

  const dataIsValid = () => {
    if (files === null) return false;
    return true;
  };

  if (isLoading) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}>
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("uploadExternalDocuments")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <FileInput
            acceptedFormats={['.html']}
            handleChange={(files) => setFiles(files)}
            preSubmitCallback={() => setFailedDocuments(null)}
          />
          <FileList
            files={files}
            filesWithError={failedDocuments}
            handleClick={() => setFiles(null)}
          />
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
          <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("uploadButtonText")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default UploadFilesAction;
